import React from 'react';
import { BannerConfirmation } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';

import { closeModal } from '../../../Utils';

const continueClick = () => {
    closeModal('banner-invite-confirmation-modal');
};

const InviteConfirmationModal = () => {
    return (
        <BannerConfirmation
            id={'banner-invite-confirmation'}
            title={`You've invited a co-client`}
            text={
                `We've sent an invitation to your co-client using the email address you provided. ` +
                `The PIN you provided expires in 21 days. After that, you'll need to resend the ` +
                `invite and provide a new PIN.`
            }
            rightButtonText={'Close'}
            createClick={continueClick}
        />
    )
};

export default InviteConfirmationModal;